
    import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

    createChat({
      target: '#n8n-chat-container',
      mode: 'fullscreen',
      webhookUrl: 'https://n8n.edrafox.com/webhook/1f04a952-106b-45b5-9711-0b8b6a92fcae/chat',
      showWelcomeScreen: false,
      loadPreviousSession: false,
      webhookConfig: {
        headers: {
          'Content-Type': 'application/json',
          'X-Instance-Id': '5613a7e90e1626044da7a672d9be4666ad0f69b9e4999d122b262ade4b4caab0',
        }
      },
      i18n: {
        en: { "inputPlaceholder": "Envie sua mensagem", "subtitle": "Conectando experiências, criando oportunidades", "title": "Olá Seja bem vindo! " },
      },
      initialMessages: ["Como posso ajudar?"],
      enableStreaming: false,
    });
  